const parseHTML = function (str) {
  var tmp = document.implementation.createHTMLDocument("");
  tmp.body.innerHTML = str;
  return tmp.body.children;
};

export default class LoadMore {
  constructor() {
    this.selector = '.c-load-more';

  }

  bootstrap() {
    document.querySelectorAll(this.selector).forEach( component => {
      const button = component.querySelector('.c-load-more__btn');
      const container = document.querySelector( component.getAttribute('data-posts-container') );
      const labelLoading = 'Loading...';

      const labelDefault = button.text;

      button.addEventListener('click', event => {
        event.preventDefault();
        button.text = labelLoading;
        button.disabled = true;

        const data = {
          'action': 'loadmore',
          'query': loadmore_params.posts,
          'page' : loadmore_params.current_page,
        };

        const params = typeof data == 'string' ? data : Object.keys(data).map(
          function(k){ return encodeURIComponent(k) + '=' + encodeURIComponent(data[k]) }
        ).join('&');


        const request = new XMLHttpRequest();
        request.open('POST', loadmore_params.ajaxurl, true);
        request.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
        request.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');

        request.onload = function() {
          button.text = labelDefault;
          button.disabled = false;

          if (this.status >= 200 && this.status < 400) {
            // Success!
            if (this.response) {
              // append posts to
              loadmore_params.current_page++;

              // remove button if reached all posts
              console.log('loadmore_params.current_page', loadmore_params.current_page);
              console.log('loadmore_params.max_page', loadmore_params.max_page);

              if ( loadmore_params.current_page == loadmore_params.max_page ) {
                if (button.parentNode !== null) {
                  button.parentNode.removeChild(button);
                }
              }

              const newCards = parseHTML(this.response);
              while (newCards.length > 0){
                container.appendChild(newCards[0]);
              }
            }

          } else {
            // We reached our target server, but it returned an error
            console.log('error returned from a server for load more');
          }
        };

        request.onerror = function() {
          // There was a connection error of some sort
          console.log('there was connection error on load more');
        };

        request.send(params);
      });

      // add intersection abserver and simply trigger button click
      let options = {
        root: document.querySelector('#scrollArea'),
        rootMargin: '0px',
        threshold: 1.0
      }

      let intersectionCallback = (entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.click();
          }
        });
      }

      let observer = new IntersectionObserver(intersectionCallback, options);
      observer.observe(button);

    });
  }
}

